import {computed, onScopeDispose, ref} from "vue";

const screenWidth = ref(window.innerWidth);

let listenerCount = 0;
const onResize = () => {
  screenWidth.value = window.innerWidth;
};

export const useResponsive = () => {
  if (listenerCount === 0) {
    window.addEventListener('resize', onResize);
  }
  listenerCount++;

  onScopeDispose(() => {
    listenerCount--;
    if (listenerCount === 0) {
      window.removeEventListener('resize', onResize);
    }
  });

  const isMobile = computed(() => {
    return screenWidth.value <= 480;
  });

  return {
    isMobile, screenWidth
  }
}
